import React from 'react';

import { currencyString } from '@consumer-frontend/nc-utils';

import '@consumer-bootstrap/netcredit.scss';

export type NcPastDueAmountPropsT = {
  amount: number;
};
export type NcPastDueAmountT = React.FC<NcPastDueAmountPropsT>;

export const NcPastDueAmount: NcPastDueAmountT = ({ amount }) => {
  return (
    <p className="payment-amount-option-label">
      <span>Past due amount</span>
      <span className="currency-amount">{currencyString(amount)}</span>
    </p>
  );
};
